import {
  DEFAULT_ICON_BUTTON_CLASS_NAME,
  COMPACT_ICON_BUTTON_CLASS_NAME,
  GO_BACK_ICON_BUTTON_CLASS_NAME,
} from '../../constants/icon-button';

const defaultIconButton = ({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
  },
});

const compactIconButton = ({ theme }) => ({
  padding: theme.spacing(0.2),
});

const goBackIconButton = ({ theme }) => ({
  width: 30,
  height: 30,
  [theme.breakpoints.up('md')]: {
    width: 48,
    height: 48,
  },
});

const MuiIconButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_ICON_BUTTON_CLASS_NAME}`]: defaultIconButton({ theme }),
      [`&.${COMPACT_ICON_BUTTON_CLASS_NAME}`]: compactIconButton({ theme }),
      [`&.${GO_BACK_ICON_BUTTON_CLASS_NAME}`]: goBackIconButton({ theme }),
    }),
  },
};
export default MuiIconButton;
